module.exports = __webpack_public_path__ + "static/0000.9a6710e15f10554ad71102b05992c93f.png";